/**
 * Il filtro per intervallo di date dei mock (FILO-41), uno per tutti: i task del core per scadenza, le
 * visite del plugin F2 per data. Come nel backend: `from` incluso, `to` escluso, estremi assenti = nessun
 * filtro, e con un estremo una data assente resta fuori.
 */
export function inMockDateRange(iso: string | null | undefined, from: string | null, to: string | null): boolean {
  if (!from && !to) return true;
  if (!iso) return false;
  const at = Date.parse(iso);
  return (!from || at >= Date.parse(from)) && (!to || at < Date.parse(to));
}
